<template>
	<div  class="filters-box-row">
		<div class="filters-container">
			<div class="time-box">
				<span>退单时间：</span>
				<el-date-picker
					@change='changeTime'
					v-model="dateValue"
					:clearable="false"
					:unlink-panels='true'
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					size="mini"
					class="time-picker"
					type="datetimerange"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format='yyyy-MM-dd HH:mm:ss'>
				</el-date-picker>
			</div>
			<div class="input-box">
				<span>退单编号：</span>
				<el-input
					v-model="refundNumber"
					placeholder="请输入订单编号"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<div class="input-box">
				<span>订单编号：</span>
				<el-input
					v-model="orderNumber"
					placeholder="请输入订单编号"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<el-button size="small" type="text" class="btn" style="color:#333;margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
			<el-button size='mini' type="primary" class="btn fx-btn" @click="search">查询</el-button>
			<el-button size="mini" plain class="btn" @click="clear">清空</el-button>
		</div>
		<div class="filters-container" v-if="!collapse" >
			<div class="input-box">
				<span>退款方式：</span>
				<el-select v-model="paymentMode" class="filter-input" size='mini'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="0" label="线下支付"></el-option>
					<el-option value="2" label="微信支付"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>退单类型：</span>
				<el-select v-model="autorefundflag" class="filter-input" size='mini'>
					<el-option :value='-1' label="全部"></el-option>
					<el-option :value='1' label="自动退单"></el-option>
					<el-option :value='0' label="手动退单"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>联系电话：</span>
				<el-input
					v-model="buyerTel"
					placeholder="请输入联系电话"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<div class="input-box">
				<span>收货地址：</span>
				<el-input
					v-model="address"
					placeholder="请输入收货地址"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<div class="input-box">
				<span>收货人：</span>
				<el-input
					v-model="buyerName"
					placeholder="请输入收货人"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
		</div>
		<div class="filters-container" v-if="!collapse" >
			<div class="input-box">
				<span>客户类别：</span>
				<el-select v-model="customerCategoryId" class="filter-input" size='small'>
					<el-option value="0" label="全部"></el-option>
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>客户名称：</span>
				<el-input
					v-model="customerName"
					placeholder="请输入客户名称"
					size="mini"
					@keyup.enter.native="search">
				</el-input>
			</div>
			<div class="input-box" v-if="active === '全部退单' || active === '退货完成'">
				<span>勾销状态：</span>
				<el-select v-model="liquidateflag" class="filter-input" size='mini'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="1" label="已勾销"></el-option>
					<el-option value="0" label="未勾销"></el-option>
				</el-select>
			</div>
			<div class="input-box" v-show="autorefundflag !== 1">
				<span>退款原因：</span>
				<el-select v-model="cause" class="filter-input" size='mini'>
					<el-option :value='-1' label="全部"></el-option>
					<el-option :value='0' label="无理由退换"></el-option>
					<el-option :value='1' label="质量问题"></el-option>
					<el-option :value='2' label="与商品描述不符合"></el-option>
					<el-option :value='3' label="卖家发错货"></el-option>
					<el-option :value='4' label="发票问题"></el-option>
					<el-option :value='5' label="其他"></el-option>
				</el-select>
			</div>
			<div class="input-box" style="width:250px" v-show="autorefundflag !== 0">
				<span>子退单状态来源：</span>
				<el-select v-model="sourcetype" class="filter-input" size='mini'>
					<el-option :value='-1' label="全部"></el-option>
					<el-option :value='3' label="待收货"></el-option>
					<el-option :value='4' label="已完成"></el-option>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'search',
	props: {
		active: {
			type: String
		},
		clddock: {
			type: Number,
			default: 0
		},
		origin: {
			type: String,
			default: ''
		},
		overrefunddock: {
			type: Number,
			default: 0
		},
		customList: {
			type: Array,
			default: () => []
		}
	},
	data () {
		return {
			collapse: false,
			dateValue: [],
			buyerTel: '',
			orderNumber: '',
			refundNumber: '',
			paymentMode: '-1',
			cause: -1,
			buyerName: '',
			pushstate: -1,
			liquidateflag: '-1',
			customerCategoryId: '0',
			customerName: '',
			sourcetype: -1,
			autorefundflag: -1,
			address: ''
		}
	},
	created () {
		let a = window.sessionStorage.getItem('startDate')
		let b = window.sessionStorage.getItem('endDate')
		if (a) {
			this.dateValue = [a, b]
		} else {
			if (!this.origin) {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			} else {
				this.dateValue = []
			}
		}
		if (window.sessionStorage.getItem('refundOrderSelect')) {
			let data = JSON.parse(window.sessionStorage.getItem('refundOrderSelect'))
			this.dateValue = data.dateValue
			this.buyerTel = data.buyerTel
			this.refundOrderNumber = data.refundOrderNumber
			this.orderNumber = data.orderNumber
			this.paymentMode = data.paymentMode
			this.buyerName = data.buyerName
			this.refundNumber = data.refundNumber
			this.cause = data.cause
			this.pushstate = data.pushstate
			this.liquidateflag = data.liquidateflag
			this.customerCategoryId = data.customerCategoryId
			this.customerName = data.customerName
			this.sourcetype = data.sourcetype
			this.autorefundflag = data.autorefundflag
			this.address = data.address
		}
	},
	methods: {
		changeTime () {
			window.sessionStorage.setItem('startDate', this.dateValue[0])
			window.sessionStorage.setItem('endDate', this.dateValue[1])
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		checkTime () {
			if (this.dateValue === null || this.dateValue.length === 0) {
				this.$message.error('请选择正确时间范围！')
				return false
			}
			var begintime = this.dateValue[0]
			var endtime = this.dateValue[1]
			// 判断时间跨度是否大于6个月
			var arr1 = begintime.split('-')
			var arr2 = endtime.split('-')
			arr1[1] = parseInt(arr1[1])
			arr1[2] = parseInt(arr1[2])
			arr2[1] = parseInt(arr2[1])
			arr2[2] = parseInt(arr2[2])
			var flag = true
			if (arr2[0] - arr1[0] > 1) {
				flag = false
			} else if (arr2[0] - arr1[0] === 1) {
				if (arr1[1] < arr2[1]) { // 月相隔大于12个月
					flag = false
				} else if (arr1[1] === arr2[1]) { // 月相隔12个月，比较日
					if (arr2[2] > arr1[2]) { // 结束日期的日大于开始日期的日
						flag = false
					}
				}
			}
			// }
			if (!flag) {
				this.$message.error('时间范围不得超过12个月！')
				return false
			}
			return true
		},

		search () {
			if (this.checkTime()) {
				this.$emit('handleSearch', { customerCategoryId: this.customerCategoryId, customerName: this.customerName, sourcetype: this.sourcetype, autorefundflag: this.autorefundflag, address: this.address, dateValue: this.dateValue, buyerTel: this.buyerTel, liquidateflag: this.liquidateflag, orderNumber: this.orderNumber, paymentMode: this.paymentMode, buyerName: this.buyerName, refundNumber: this.refundNumber, cause: this.cause, pushstate: this.pushstate })
			}
		},
		// 导出
		exportExcel () {
			this.$emit('exportExcel')
		},
		clear () {
			this.clearInput1()
			this.search()
		},
		clearInput1 () {
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59']
			window.sessionStorage.setItem('startDate', this.dateValue[0])
			window.sessionStorage.setItem('endDate', this.dateValue[1])
			this.buyerTel = ''
			this.orderNumber = ''
			this.refundNumber = ''
			this.paymentMode = '-1'
			this.buyerName = ''
			this.cause = -1
			this.pushstate = -1
			this.liquidateflag = '-1'
			this.customerCategoryId = '0'
			this.customerName = ''
			this.sourcetype = -1
			this.autorefundflag = -1
			this.address = ''
		},
		clearInput () {
			this.buyerTel = ''
			this.orderNumber = ''
			this.refundNumber = ''
			this.paymentMode = '-1'
			this.buyerName = ''
			this.cause = -1
			this.pushstate = -1
			this.liquidateflag = '-1'
			this.customerCategoryId = '0'
			this.customerName = ''
			this.sourcetype = -1
			this.autorefundflag = -1
			this.address = ''
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	flex-direction column
	padding: 10px 0;
	width :100%;
	line-height :50px;
	min-width :600px;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		height: 50px
		.input-box {
			display flex
			width: 220px
			span {
				margin-right: 10px
			}
			.el-input{
				width :140px
			}
			.filter-input {
				width:140px
			}
		}
		.time-box {
			display flex
			width: 440px
			.time-picker{
				width :360px
				margin-top :10px
			}
			span {
				margin-right: 10px
			}
			.filter-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 10px
		}
		.batch-register-btn{
			cursor :pointer;
			color: var(--fx-primary-color);
			font-size: 12px;
			margin-top: 10px;
			display: flex;
			width: 70px;
			height: 32px;
			justify-content: center;
			align-items: center;
		}
		.excel-icon {
			display inline-block
			height 20px
			width 20px
			background-repeat no-repeat
			background-position center
			&.import-excel-icon {
				background-image: url('~images/icon/import-excel-icon.png')
			}
			&.export-excel-icon {
				background-image: url('~images/icon/export-excel-icon.png')
			}
		}
	}
	.input-box {
		display flex
		span {
			margin-right: 10px
		}
		.el-input{
			width :180px
		}
		.filter-input {
			width:170px
		}
	}
}
</style>
